export const enum PopupModalEvent {
  OK_BUTTON_EVENT = 1,
  CLOSE_BUTTON_EVENT = 0,
  OTHER_EVENT = -1,
}
